import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../../lib/motion";

export default function Topics() {
    return (
        <section
            id="topics"
            className="relative border-b border-hairline bg-page text-ink py-24 lg:py-36"
            data-testid="topics-section"
        >
            {/* subtle deco */}
            <div className="pointer-events-none absolute -top-24 -right-16 -z-0 h-[420px] w-[420px] animate-blob rounded-full bg-coral/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-20 -left-10 -z-0 h-[360px] w-[360px] animate-blob rounded-full bg-sun/15 blur-3xl" />

            <div className="relative mx-auto grid max-w-[1400px] gap-12 px-5 lg:grid-cols-12 lg:items-center lg:gap-16 lg:px-10">
                <div className="lg:col-span-7">
                    <Reveal>
                        <div className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-coral">
                            // Chapter 05 · The playbook
                        </div>
                        <h2
                            className="font-display text-5xl font-black leading-[0.95] tracking-tight text-ink sm:text-6xl lg:text-7xl"
                            data-testid="topics-headline"
                        >
                            Topics you{" "}
                            <span className="font-serif italic font-normal text-coral">
                                NEED
                            </span>
                            <br />
                            to know about.
                        </h2>
                        <p className="mt-8 max-w-xl text-base leading-relaxed text-ink/75 lg:text-lg">
                            A no-fluff playbook of the marketing basics every small business
                            should have sorted before spending a dollar. Read it, see it, or tick
                            it off — whichever way you learn best.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-5 lg:justify-self-end">
                    <Reveal>
                        <Link
                            to="/where-should-i-start"
                            className="group relative inline-flex flex-col justify-between gap-14 border-2 border-coral bg-coral p-8 text-white transition-all hover:-translate-y-1 hover:frame lg:h-[280px] lg:w-[380px] lg:p-10"
                            data-testid="topics-cta"
                        >
                            <div className="flex items-start justify-between">
                                <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-white/80">
                                    Open the playbook
                                </span>
                                <ArrowUpRight className="h-6 w-6 shrink-0 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                            </div>
                            <div>
                                <div className="font-display text-6xl font-black uppercase leading-[0.9] tracking-tight lg:text-7xl">
                                    Topics
                                </div>
                                <div className="mt-3 font-serif text-lg italic text-white/85">
                                    Where should I start?
                                </div>
                            </div>
                        </Link>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
